import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormatEnum } from '../../../../pipes/format-enum';
import { CapitalizePipe } from '../../../../pipes/capitalize-text';

@Component({
  selector: 'app-country-filter',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormatEnum, CapitalizePipe],
  templateUrl: './country-filter.component.html',
  styleUrl: './country-filter.component.scss'
})
export class CountryFilterComponent {
  @Input() statuses: string[] = [];
  @Input() includeAll: boolean = true;
  @Input() useTranslate: boolean = true;
  @Output() close = new EventEmitter<string>();

  isStatusOpen = false;
  selectedOption: string = 'All';

  get sortingTypeDictionary(): string[] {
    return this.includeAll ? ['All', ...this.statuses] : [...this.statuses];
  }

  toggleModal(option?: string) {
    if (option) {
      this.selectedOption = this.sortingTypeDictionary.includes(option)
        ? option
        : this.selectedOption;
      this.close.emit(option);
    }
    this.isStatusOpen = !this.isStatusOpen;
  }

  capitalize(text: string): string {
    if (!text) return '';
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
